module.exports = __webpack_public_path__ + "media/images/przedszkole1-1c57300dfe7063aed97eaba37ae47f14.png";